import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IChartTemplateRound, defaultValue } from '../../model/chart-template-round.model';

export const ACTION_TYPES = {
  FETCH_CHARTTEMPLATEROUND_LIST: 'chartTemplateRound/FETCH_CHARTTEMPLATEROUND_LIST',
  FETCH_CHARTTEMPLATEROUND: 'chartTemplateRound/FETCH_CHARTTEMPLATEROUND',
  CREATE_CHARTTEMPLATEROUND: 'chartTemplateRound/CREATE_CHARTTEMPLATEROUND',
  UPDATE_CHARTTEMPLATEROUND: 'chartTemplateRound/UPDATE_CHARTTEMPLATEROUND',
  DELETE_CHARTTEMPLATEROUND: 'chartTemplateRound/DELETE_CHARTTEMPLATEROUND',
  RESET: 'chartTemplateRound/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IChartTemplateRound>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ChartTemplateRoundState = Readonly<typeof initialState>;

// Reducer

export default (state: ChartTemplateRoundState = initialState, action): ChartTemplateRoundState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CHARTTEMPLATEROUND):
    case REQUEST(ACTION_TYPES.UPDATE_CHARTTEMPLATEROUND):
    case REQUEST(ACTION_TYPES.DELETE_CHARTTEMPLATEROUND):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND):
    case FAILURE(ACTION_TYPES.CREATE_CHARTTEMPLATEROUND):
    case FAILURE(ACTION_TYPES.UPDATE_CHARTTEMPLATEROUND):
    case FAILURE(ACTION_TYPES.DELETE_CHARTTEMPLATEROUND):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATEROUND):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CHARTTEMPLATEROUND):
    case SUCCESS(ACTION_TYPES.UPDATE_CHARTTEMPLATEROUND):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CHARTTEMPLATEROUND):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/chart-template-rounds';

// Actions

export const getEntities: ICrudGetAllAction<IChartTemplateRound> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATEROUND_LIST,
    payload: axios.get<IChartTemplateRound>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IChartTemplateRound> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATEROUND,
    payload: axios.get<IChartTemplateRound>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IChartTemplateRound> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CHARTTEMPLATEROUND,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IChartTemplateRound> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CHARTTEMPLATEROUND,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IChartTemplateRound> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CHARTTEMPLATEROUND,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
